import React, { FC } from 'react';
import classnames from 'classnames';

import { Edition } from 'components/editions/Edition';

import { EditionDecoration } from './EditionDecoration';

import * as Types from 'types';

type Props = {
  edition: Types.EditionWithArtwork;
  isMinted: boolean;
  className?: string;
  headlineEnabled?: boolean;
};

export const NftEdition: FC<Props> = ({ edition, isMinted, className, headlineEnabled = true }) => (
  <div className={classnames('nft-edition', className, { 'nft-edition--minted': isMinted })}>
    {headlineEnabled && (
      <div className='minting-flow__headline-container mb-2 pb-1 pb-lg-0 mb-lg-0'>
        <h2 className='nft-edition__headline headline headline--medium'>
          {isMinted ? 'NFT Artwork' : 'Artwork'}
        </h2>
      </div>
    )}
    <EditionDecoration showDecoration={isMinted}>
      <Edition
        edition={edition}
        artwork={edition.artwork}
        context='modal'
        nftIndicatorEnabled={false}
      />
    </EditionDecoration>
  </div>
);
